/*
 * Marketfit · Título dinámico según variante
 *
 * Cuando un producto tiene una opción cuyos valores solo difieren en una
 * cantidad + unidad (p.ej. "Creatina UN 150g" / "Creatina UN 250g" / "Creatina UN 500g"),
 * y esa misma cantidad aparece escrita en el título del producto (H1) y en el
 * breadcrumb, este script mantiene ese número sincronizado con lo que el
 * cliente elige — sin tocar nada si el patrón no aplica al producto.
 *
 * No requiere cambios en Liquid más allá de incluir este archivo: lee los
 * valores directamente del selector de variantes ya renderizado en pantalla.
 */
(function () {
  function extractToken(str) {
    if (!str) return null;
    var m = String(str).match(/(\d+(?:[.,]\d+)?\s?(?:kg|gr|g|ml|lb|l))\b(?!.*\d)/i);
    return m ? m[1].replace(/\s+/g, ' ').trim() : null;
  }

  function findSizeOption(productInfo) {
    var fieldsets = productInfo.querySelectorAll('.product-form__input--variant-picker');
    for (var i = 0; i < fieldsets.length; i++) {
      var fieldset = fieldsets[i];
      var radios = fieldset.querySelectorAll('input[type="radio"]');
      var values, getCurrentValue;

      if (radios.length) {
        values = Array.prototype.map.call(radios, function (el) { return el.value; });
        getCurrentValue = function () {
          var checked = fieldset.querySelector('input[type="radio"]:checked');
          return checked ? checked.value : null;
        };
      } else {
        var select = fieldset.querySelector('select');
        if (!select || !select.options.length) continue;
        values = Array.prototype.map.call(select.options, function (o) { return o.value; });
        getCurrentValue = function () { return select.value; };
      }

      if (values.length < 2) continue;

      var tokens = values.map(extractToken);
      if (tokens.indexOf(null) !== -1) continue;

      var prefixes = values.map(function (v, idx) { return v.replace(tokens[idx], '').trim(); });
      var samePrefix = prefixes.every(function (p) { return p === prefixes[0]; });
      var uniqueTokenCount = tokens.filter(function (t, idx) { return tokens.indexOf(t) === idx; }).length;

      if (!samePrefix || uniqueTokenCount < 2) continue;

      return { getCurrentToken: function () { return extractToken(getCurrentValue()); } };
    }
    return null;
  }

  function initTitleSync(productInfo) {
    if (productInfo.dataset.mfTitleSync) return;
    productInfo.dataset.mfTitleSync = 'true';

    var titleEl = productInfo.querySelector('.product__title h1');
    var crumbEl = document.querySelector('.breadcrumb__list li:last-child');

    var sizeOption = findSizeOption(productInfo);
    if (!sizeOption || !titleEl) return;

    var currentToken = sizeOption.getCurrentToken();
    if (!currentToken || titleEl.textContent.indexOf(currentToken) === -1) return; // el título no contiene ese texto: no tocar nada

    var state = { token: currentToken };

    productInfo.addEventListener('change', function () {
      // esperar un tick a que el input recién clickeado quede "checked"
      setTimeout(function () {
        var freshSizeOption = findSizeOption(productInfo);
        if (!freshSizeOption) return;

        var newToken = freshSizeOption.getCurrentToken();
        if (!newToken || newToken === state.token) return;

        [titleEl, crumbEl].forEach(function (el) {
          if (el && el.textContent.indexOf(state.token) !== -1) {
            el.textContent = el.textContent.replace(state.token, newToken);
          }
        });

        state.token = newToken;
      }, 0);
    });
  }

  function initAll() {
    document.querySelectorAll('product-info').forEach(initTitleSync);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
